import { stringifyParams, withTransformResponse } from '../../lib/utils';
import { transformGetProvidersInputForApi } from './types/';
import { normalizeProvidersResData } from './types';
/**
 * Query function for retrieving appointment slots.
 *
 * @param client the internal client instance
 * @param config the internal client configuration object
 * @param input input parameters for paring down the search results
 *
 * @category Query Functions - getProviders
 * @category Query Functions
 */
export const getProviders = (client, config, input) => {
    const { customerCode } = config;
    return client.get(`/${customerCode}/providers`, {
        params: input,
        paramsSerializer: (params) => {
            const transformedParams = transformGetProvidersInputForApi(params);
            return stringifyParams(transformedParams);
        },
        transformResponse: withTransformResponse(client, [
            normalizeProvidersResData
        ])
    });
};
//# sourceMappingURL=getProviders.js.map